import React from 'react';
import { Img } from 'remotion';
import { LayerWrapper } from './LayerWrapper';
import type { WatermarkLayer as WatermarkLayerConfig, UploadedAsset } from '../../types';

interface WatermarkLayerProps {
  layer: WatermarkLayerConfig;
  asset?: UploadedAsset;
}

export function WatermarkLayer({ layer, asset }: WatermarkLayerProps) {
  if (!asset) return null;

  return (
    <LayerWrapper position={layer.position} animation={layer.animation} opacity={layer.opacity}>
      <Img
        src={asset.url}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    </LayerWrapper>
  );
}
